import RadioButtonWrapper from "./RadioButtonWrapper"

const ItemPerfomancesRadioButton = ({
    id,
    name,
    value,
    currentValue,
    label,
    onChange
}) => {
    return (
        <RadioButtonWrapper id={id} label={label}>
            <input
                name={name}
                id={id}
                type="radio"
                value={value}
                checked={currentValue === value}
                onChange={() => onChange(value)}
                className='radio-button'
            />
        </RadioButtonWrapper>
    )
}
export default ItemPerfomancesRadioButton